import { gql } from '@apollo/client';

export const fetchTransactionAccountForEntitlement = gql`
  query fetchTransactionAccountForEntitlement($entitlementId: String, $searchOptions: ConnectionSearchOptions) {
    entitlementDetails(id: $entitlementId) {
      id
      termDetails {
        availableCreditLimit
        currency
        totalCreditLimit
      }
      transactionAccount {
        id
        displayName
        partnerLevel
        partnerDiscountTier
        programLevelGlobal
        transactionAccountNumber
        partnerAccountId
        availablePaymentMethods {
          totalCount
          nodes {
            id
            type
            default
            paymentIssue
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
          }
        }
        billToParty {
          name
          addressLine1
          addressLine2
          city
          state
          country
          postcode
          taxId
          taxIds {
            id
            label
          }
          taxLabels {
            region
            taxIdLabels {
              description
              displayName
              type
              metadata {
                type
                labels {
                  default
                  label
                  vatStatus
                }
              }
            }
          }
        }
        billToPartyPricingEligibilty
        defaultPaymentMethod {
          type
          paymentIssue
          ... on CreditCard {
            card {
              last4Numbers
              expirationMonth
              expirationYear
              brand
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
            }
          }
        }
        billingAdmins(searchOptions: $searchOptions) {
          totalCount
          nodes {
            email
            atlassianAccountId
            fullName
          }
        }
        availableInvoiceGroups {
          totalCount
          nodes {
            id
            name
            currency
            shipToParty {
              id
              name
              addressLine1
              addressLine2
              city
              state
              country
              postcode
              taxId
              taxIds {
                id
                label
              }
              taxLabels {
                region
                taxIdLabels {
                  description
                  displayName
                  type
                  metadata {
                    type
                    labels {
                      default
                      label
                      vatStatus
                    }
                  }
                }
              }
            }
            shipToPriceEligibility
            defaultPaymentMethod {
              type
              paymentIssue
              ... on CreditCard {
                card {
                  expirationMonth
                  expirationYear
                  last4Numbers
                  brand
                }
              }
              ... on PaymentOnTerms {
                terms {
                  invoiceDueDays
                }
              }
            }
            purchaseOrder {
              number
              oneTimeUse
            }
          }
        }
      }
    }
  }
`;
